import React from "react";
import {Box, CircularProgress} from "@mui/material";

export function CustomLoader() {
    return <Box justifyContent={"center"} width={"100%"} display={"flex"} p={16}>
        <CircularProgress size={50} color={"primary"}/>
    </Box>
}
